import React from 'react'
import useStore from '../../store/store';
import '../../App.scss';
import DeleteIcon from '../shared/DeleteIcon';
import { childType } from '../ChildSelect';
import NavigationMobile from './NavigationMobile';

const PeopleCountMobile = () => {
  const {
    rooms,
    addRoom,
    removeRoom,
    step,
    updateRoomAdults,
    addChildToRoom,
    removeChildFromRoom
  } = useStore((state) => state);

  const handleDeleteRoomVision = (roomId) => {
    return roomId === rooms.length - 1 && roomId > 0 ? 'flex' : 'none'
  }
  return (
    <div className='MobileMain__wrapper'>
      <div className='MobileMain__step roboto-regular'>Шаг {step}/5</div>

      <h2>Количество гостей</h2>

      <div className='PeopleCountMobile__rooms'>
        {rooms.map(room => {
          let adults = room.people.filter(item => item.type === 'adult').length;
          return (
            <div className='PeopleCountMobile__room' key={`room-${room.id}`}>
              <div className='main__header'>
                <h3>Номер {room.id + 1}</h3>
                <span style={{ display: handleDeleteRoomVision(room.id) }} className='delete_room' onClick={removeRoom}>
                  <DeleteIcon /> Удалить
                </span>
              </div>

              <div className='PeopleCountMobile__room_people-count'>
                <span className='PeopleCountMobile__room_people-title adult'>Взрослые</span>

                <div className='count-handler'>
                  <span className='count-handler__prev' onClick={() => updateRoomAdults(room.id, adults > 1 ? adults - 1 : 1)}></span>

                  <span className='count-handler__count'>{room.people.filter(item => item.type === 'adult').length}</span>

                  <span className='count-handler__next' onClick={() => updateRoomAdults(room.id, adults < 3 ? adults + 1 : 3)}></span>
                </div>
              </div>

              <div className='PeopleCountMobile__room_people-count'>
                <div style={{ flex: 1 }}>
                  <span className='PeopleCountMobile__room_people-title'>Дети</span>

                  <div className='PeopleCountMobile__room_childs-list'>
                    {childType.map(item => (
                      <div key={item.name} className='count-handler__child_wrapper'>
                        {item.name.replace('Ребенок ', '')}

                        <div className='count-handler'>
                          <span
                            className='count-handler__prev'
                            onClick={
                              () =>
                                removeChildFromRoom(room.id, room.people.findIndex(ppl => item.guest_id === ppl.guest_id))
                            }>
                          </span>

                          <span className='count-handler__count'>
                            {room.people.filter(ppl => ppl.type === 'child' && item.guest_id === ppl.guest_id).length}
                          </span>

                          <span 
                            className='count-handler__next' 
                            onClick={
                              () => 
                              room.people.length < 4 
                              ? addChildToRoom(room.id, null, item.name, item.guest_id) 
                              : null
                              }>
                          </span>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>
            </div>
          )
        })}
        <button className='calc_button' onClick={() => addRoom()}>Добавить номер</button>
      </div>
      <NavigationMobile />
    </div>
  )
}

export default PeopleCountMobile